import React, { useContext, useEffect } from 'react';

import {
    Autocomplete,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { CompetenzaContext } from '../CompetenzaContext';

import { Field, Formik } from 'formik';
import moment from 'moment';
import { useParams } from "react-router-dom";
import * as Yup from 'yup';
import { DateTableRow, UtenteTableRow } from '../../../common';

const CompetenzaSchema = Yup.object().shape({
    tipoUfficioId: Yup.number().required("Il tipo d'ufficio è un campo obbligatorio"),
});

export const CompetenzaDetails = ({
    disabled,
    formRef,
    onActionClick,
    ...props
}) => {

    const {
        state,
        setState,

        isLoadingUffici,
        getUfficiAsync,

    } = useContext(CompetenzaContext);

    const {
        competenza,
        uffici,
        ufficiOptions,
        tipiUffici,
        tipiUfficiOptions,
    } = state;

    const { competenzaId } = useParams();

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    const massiveAssignmentClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("MassiveAssignment", data);
    }

    useEffect(() => {
        if (!tipiUffici || competenzaId) return;

        var sorted = tipiUffici.result.sort((a, b) => a.dataCreazione - b.dataCreazione);
        sorted.length > 0 && formRef.current.setFieldValue('tipoUfficioId', sorted[0].id);
    }, [tipiUffici]);

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        tipoUfficioId: competenza?.tipoUfficioId ?? null,
                        messaggioDefault: competenza?.messaggioDefault ?? "",
                        ufficioDefaultId: competenza?.ufficioDefaultId ?? null,
                        inizioValidita: competenza?.inizioValidita ?? moment.utc([1946, 5, 2]),
                        fineValidita: competenza?.fineValidita ?? null,
                    }
                }
                enableReinitialize
                validationSchema={CompetenzaSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {


                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justifyContent="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                                {
                                                    competenza &&
                                                    <Grid item>
                                                        <Button
                                                            variant="contained"
                                                            disableElevation
                                                            color="info"
                                                            disabled={disabled}
                                                            onClick={massiveAssignmentClickHandler}
                                                            style={{ marginLeft: 8 }}
                                                        >
                                                            Assegnazione
                                                        </Button>
                                                    </Grid>
                                                }
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Tipo ufficio
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="tipoUfficioId"
                                                            component={Autocomplete}
                                                            options={tipiUfficiOptions}
                                                            onChange={(e, value) => {
                                                                setFieldValue('tipoUfficioId', value?.tipoUfficioId);
                                                                if (value?.tipoUfficioId)
                                                                    getUfficiAsync(value?.tipoUfficioId);
                                                            }}
                                                            value={tipiUfficiOptions.find(option => option.tipoUfficioId == values.tipoUfficioId) ?? null}
                                                            renderInput={(params) => <TextField {...params}
                                                                label="Scegli..." />}
                                                            fullWidth
                                                        />
                                                        {
                                                            errors.tipoUfficioId &&
                                                            <Typography color="error">
                                                                {errors.tipoUfficioId}
                                                            </Typography>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Ufficio nazionale
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="ufficioDefaultId"
                                                            component={Autocomplete}
                                                            options={ufficiOptions}
                                                            onChange={(e, value) => {
                                                                setFieldValue('ufficioDefaultId', value?.ufficioId);
                                                            }}
                                                            value={ufficiOptions.find(option => option.ufficioId == values.ufficioDefaultId) ?? null}
                                                            renderInput={(params) => <TextField {...params}
                                                                label="Scegli..." />}
                                                            fullWidth
                                                            disabled={!values.tipoUfficioId}
                                                        />
                                                        {
                                                            errors.ufficioId &&
                                                            <Typography color="error">
                                                                {errors.ufficioId}
                                                            </Typography>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Messaggio in caso di Competenza non assegnata al Comune
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="messaggioDefault"
                                                            name="messaggioDefault"
                                                            value={values.messaggioDefault}
                                                            onChange={handleChange}
                                                            error={touched.messaggioDefault && Boolean(errors.messaggioDefault)}
                                                            helperText={touched.messaggioDefault && errors.messaggioDefault}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Inizio validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="inizioValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('inizioValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.inizioValidita}
                                                            fullWidth
                                                            renderInput={(params) =>
                                                                <TextField
                                                                    helperText={touched.inizioValidita && errors.inizioValidita}
                                                                    {...params}
                                                                />
                                                            }
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Fine validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="fineValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('fineValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.fineValidita}
                                                            fullWidth
                                                            renderInput={(params) =>
                                                                <TextField
                                                                    helperText={touched.fineValidita && errors.fineValidita}
                                                                    {...params}
                                                                />
                                                            }
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={competenza?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={competenza?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={competenza?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={competenza?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}